import styled from "styled-components";

export const CardWrapper = styled.div`
  width: 270px;
`;

export const ContentContainer = styled.div`
  display: flex;
  padding: 13px;
`;

export const AvatarContainer = styled.div`
  padding-inline-end: 10px;
  align-self: center;
`;

export const TextSection = styled.div`
  width: 210px;
`;
